import { useTranslation } from 'react-i18next';
import Container from '@/components/ui/Container';
import SectionHeading from '@/components/ui/SectionHeading';
import FeatureCard from './FeatureCard';
import {
  QrCodeIcon,
  ShieldCheckIcon,
  DownloadIcon,
  SparklesIcon,
  ArrowPathIcon,
} from '@/components/icons';

const featureKeys = ['qrSharing', 'protection', 'oneTap', 'customizable', 'alwaysCurrent'] as const;

const featureIcons = {
  qrSharing: QrCodeIcon,
  protection: ShieldCheckIcon,
  oneTap: DownloadIcon,
  customizable: SparklesIcon,
  alwaysCurrent: ArrowPathIcon,
};

export default function Features() {
  const { t } = useTranslation();

  const features = featureKeys.map((key, index) => ({
    icon: featureIcons[key],
    title: t(`features.${key}.title`),
    description: t(`features.${key}.description`),
    featured: index === 0,
  }));

  return (
    <section className="py-20 md:py-28 bg-white">
      <Container>
        <SectionHeading
          title={t('features.title')}
          subtitle={t('features.subtitle')}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <FeatureCard
              key={featureKeys[index]}
              {...feature}
              delay={index * 0.1}
            />
          ))}
        </div>
      </Container>
    </section>
  );
}
